import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { SrIcon } from "@/components/ui/SrIcon";
import { useImpersonation } from "@/contexts/ImpersonationContext";
import { useImportCustomers } from "@/hooks/use-import-customers";

export default function IntegrasjonerSettings() {
  const { activeUser } = useImpersonation();
  const canManageSettings =
    activeUser?.role === "admin" || activeUser?.role === "superadmin";
  const importCustomers = useImportCustomers();

  if (!canManageSettings) {
    return (
      <div className="page-container">
        <p className="text-sm text-muted-foreground">Du har ikke tilgang.</p>
      </div>
    );
  }

  return (
    <div className="page-container animate-fade-in space-y-6">
      <h1 className="font-display font-semibold text-[clamp(28px,3vw,40px)] tracking-[-0.01em] flex items-center gap-2 mb-6">
        <SrIcon name="plug" className="h-6 w-6" />
        Integrasjoner
      </h1>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center gap-2 mb-4">
            <SrIcon name="plug" className="h-4 w-4 text-muted-foreground" />
            <h2 className="font-display text-base">Integrasjoner</h2>
          </div>
          <div className="p-4 rounded-lg border border-border/50 bg-card/50 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div>
              <p className="font-medium text-sm">PowerOffice Go – kunder</p>
              <p className="text-xs text-muted-foreground">
                Synkroniseres automatisk hver natt. Trykk for å hente kunder nå.
              </p>
            </div>
            <div className="flex items-center gap-2">
              <Badge variant="secondary" className="bg-success/10 text-success text-xs">
                Tilkoblet
              </Badge>
              <Button
                variant="outline"
                size="sm"
                onClick={() => importCustomers.mutate()}
                disabled={importCustomers.isPending}
              >
                <SrIcon
                  name={importCustomers.isPending ? "loader2" : "refresh-cw"}
                  className={`w-3 h-3 mr-1 ${importCustomers.isPending ? "animate-spin" : ""}`}
                />
                {importCustomers.isPending ? "Synkroniserer…" : "Synk kunder nå"}
              </Button>
            </div>
          </div>
          <div className="p-4 mt-3 rounded-lg border border-border/50 bg-card/50 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div>
              <p className="font-medium text-sm">Monday (tidsregistreringer)</p>
              <p className="text-xs text-muted-foreground">
                Manuell import per ansatt — kun superadmin
              </p>
            </div>
            <Link to="/admin/import?tab=time">
              <Button variant="outline" size="sm">
                <SrIcon name="upload" className="w-3 h-3 mr-1" />
                Åpne import
              </Button>
            </Link>
          </div>
          <div className="p-4 mt-3 rounded-lg border border-border/50 bg-card/50 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div>
              <p className="font-medium text-sm">Monday (prosjektoppdateringer)</p>
              <p className="text-xs text-muted-foreground">
                Manuell import per board og gruppe — kun superadmin
              </p>
            </div>
            <Link to="/admin/import?tab=comments">
              <Button variant="outline" size="sm">
                <SrIcon name="message-square" className="w-3 h-3 mr-1" />
                Åpne import
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
